module.exports = __webpack_public_path__ + "img/company26.79d002d6.png";